// Feature flags. ffmpeg.wasm in-browser rendering is a documented stretch goal:
// GitHub Pages cannot serve the COOP/COEP headers needed for the multithreaded
// core, and long OTB footage does not fit comfortably in wasm memory. The
// supported compile path is the exported render kit + local ffmpeg.
export const FEATURES = {
  ffmpegWasm: false,
}

// Board color themes. Single source of truth: the live overlay injects these
// as CSS and the PNG export renderer reads them directly, so preview == export.
export const BOARD_THEMES = {
  brown: { label: 'Brown', light: '#F0D9B5', dark: '#B58863' },
  walnut: { label: 'Walnut', light: '#EDD6B0', dark: '#B88762' },
  green: { label: 'Green', light: '#FFFFDD', dark: '#86A666' },
  blue: { label: 'Blue', light: '#DEE3E6', dark: '#8CA2AD' },
  slate: { label: 'Slate', light: '#CACCCE', dark: '#7D8796' },
  charcoal: { label: 'Charcoal', light: '#B8BEC4', dark: '#4B5259' },
}

// Piece sprite sets shipped with cm-chessboard (files under assets/pieces/).
export const PIECE_SETS = {
  standard: { label: 'Standard', file: 'standard.svg' },
  staunty: { label: 'Staunty', file: 'staunty.svg' },
}

export const FPS_PRESETS = [23.976, 24, 25, 29.97, 30, 50, 59.94, 60]

export const DEFAULT_OVERLAY = {
  // 'overlay' floats the board over the footage; 'split' composes the classic
  // Shorts canvas — full-width board panel on top, footage cropped below.
  mode: 'overlay',
  split: {
    share: 1080 / 1920, // board panel height as a fraction of the 9:16 frame (full-width board)
    pos: 0.5, // crop framing along the overflowing axis (0 = left/top, 1 = right/bottom)
  },
  x: 0.29, // top-left, fraction of video content-box width
  y: 0.03, // top-left, fraction of video content-box height
  size: 0.42, // board side, fraction of video content-box height
  theme: 'brown',
  pieces: 'standard',
  orientation: 'white',
  coords: false,
  opacity: 1,
  visible: true,
  showBefore: true, // show the starting position before the first timestamp
  customized: false, // becomes true once the user drags/resizes; until then we auto-center on video load
}

export const DEFAULT_PREFS = {
  // Pre-fill timestamps as an editable scaffold when a game + video are both
  // present and nothing has been tagged yet. Never overwrites existing tags.
  autoFill: true,
  // 'even' spreads moves uniformly; 'paced' follows the typical think-time
  // arc of real games (opt-in, see lib/distribute.js).
  curve: 'even',
}

export const STORAGE_KEY = 'pgn-sync:project:v1'

// Where the copied cm-chessboard runtime assets (CSS themes, piece sprites)
// are served from — see viteStaticCopy in vite.config.js.
export const CM_ASSETS_URL = `${import.meta.env.BASE_URL}assets/cm-chessboard/`

export const SAMPLE_PGN = `[Event "A Night at the Opera"]
[Site "Paris FRA"]
[Date "1858.11.02"]
[White "Paul Morphy"]
[Black "Duke Karl / Count Isouard"]
[Result "1-0"]

1. e4 e5 2. Nf3 d6 3. d4 Bg4 4. dxe5 Bxf3 5. Qxf3 dxe5 6. Bc4 Nf6 7. Qb3 Qe7
8. Nc3 c6 9. Bg5 b5 10. Nxb5 cxb5 11. Bxb5+ Nbd7 12. O-O-O Rd8 13. Rxd7 Rxd7
14. Rd1 Qe6 15. Bxd7+ Nxd7 16. Qb8+ Nxb8 17. Rd8# 1-0
`
